import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { SUPPLIER_GENERAL_FORM } from "src/app/controller/constants/forms-config";
import { AbstractFormComponent } from "../abstract-form.component";
import { getCountries, getCountryCallingCode } from "libphonenumber-js";
import * as emojiFlags from "emoji-flags";

@Component({
  selector: "app-general",
  templateUrl: "./general.component.html",
  styleUrls: ["./general.component.css"],
  host: {
    class: "css-form",
  },
  standalone: false,
})
export class GeneralComponent extends AbstractFormComponent implements OnInit {
  form: any = {
    name: null,
    street: null,
    postcode: null,
    network: null,
    residence: null,
    phone: null,
    fax: null,
    mail: null,
    legalForm: null,
  };

  constructor(http: HttpClient) {
    super(http);
  }

  ID: number = SUPPLIER_GENERAL_FORM.ID;
  TITLE: string = SUPPLIER_GENERAL_FORM.TITLE;
  PATH: string = SUPPLIER_GENERAL_FORM.PATH;

  countryCodes: any[] = [];

  async loadCountryCodes() {
    let countries: any[] = [];

    for (const iso2 of getCountries()) {
      const flagData = emojiFlags.countryCode(iso2);
      countries.push({
        code: '+' + getCountryCallingCode(iso2),
        flag: flagData?.emoji || "",
      });
    }

    this.countryCodes = countries.filter((element, index) => {
      return countries.indexOf(element) === index;
    });
  }

  getFormValues() {
    return this.form;
  }

  setFormValues(formValues: any): void {
    this.loadCountryCodes().then(() => {
      this.form = formValues;
    });
  }

  getSheetName(): string {
    return "general";
  }

  getCountryCode(phoneNumber: string) {
    let cc = this.countryCodes.find((cc) => phoneNumber.indexOf(cc.code) > -1);
    return cc ? cc.code : "";
  }

  getPhoneNumber(phoneNumber: string) {
    let cc = this.getCountryCode(phoneNumber);
    return phoneNumber.substring(cc.length - 1);
  }

  ngOnInit(): void {}
}
